import { Component, input, InputSignal } from "@angular/core";
import { FeltAlternativ, FeltCheckboxgruppeComponent, FormRoot } from "@husbanken/designsystem-angular-forms";
import { FormArray } from "@angular/forms";

/**
 * Multiple choice question component.
 * Used when **multiple** alternatives can be selected.
 */
@Component({
  selector: "bko-flervalg-sporsmal",
  imports: [FeltCheckboxgruppeComponent],
  templateUrl: "./flervalg.html",
  styleUrl: "./flervalg.scss",
})
export class Flervalg {
  readonly alternatives: InputSignal<FeltAlternativ[]> = input([
    {
      key: "a1",
      tekst: "Kjøkken",
    },
    {
      key: "a2",
      tekst: "Stue",
    },
    {
      key: "a3",
      tekst: "Soverom",
    },
  ]);
  form = input.required<FormRoot<{ control: FormArray }>>();

  legendText: string = "Velg alle som gjelder";
}
